import * as types from '../constants/actionTypes';
import * as currencyActions from "../graphql/actions/currency";
import {addNotification as notify} from 'reapop';
import l10n from "../l10n/localization";




export function fetchCurrencies() {
    return dispatch => {
        dispatch(loading());
        currencyActions.getCurrencies(
            function(response) {
                dispatch(receiveCurrencies(response.data.currencies));
            },
            function(error) {
                dispatch(notify({message: error.message, status: 'error'}));
            }
        );
    }
}

export function edit(currency) {
    let id = currency.id;
    delete currency.id;
    delete currency.__typename;

    return dispatch => {
        dispatch(saving(currency));
        currencyActions.edit(
            function (response) {
                dispatch(saved(response.data.editCurrency));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            currency
        );
    };
}


export function loading()
{
    return {
        type: types.LOADING_CURRENCY
    };
}

export function saving(currency) {
    return {
        type: types.SAVING_CURRENCY,
        payload: currency
    };
}

export function saved(currency) {
    return {
        type: types.SAVED_CURRENCY,
        payload: currency
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_CURRENCY,
    };
}

export function receiveCurrencies(currencies)
{
    return {
        type: types.RECEIVED_CURRENCY,
        payload: currencies
    };
}



// WEBPACK FOOTER //
// ./src/actions/currency.js